













































import { Component, Prop, Vue } from "vue-property-decorator";
import { IClient } from "@/models/clients";

@Component({
  components: {
    "client-provider": () =>
      import("@/components/app/global/client/clientProvider.vue"),
    "client-profile-card": () =>
      import("@/components/app/global/client/clientProfileCard.vue"),
    "client-blocked-notification": () =>
      import("@/components/app/global/fraud/clientBlockedNotification.vue"),
    "fraud-provider": () =>
      import("@/components/app/global/fraud/fraudProvider.vue")
  }
})
export default class AdminClientView extends Vue {
  // Props
  @Prop({ default: () => [] })
  public routes!: (vm: AdminClientView & any) => any[];
  // Data
  public clientId: IClient["id"] = this.$route.params.clientId;
  // Life-cycle methods
  public mounted() {
    this.$bus.$emit("scrollToTop");
  }
}
